import { Component, inject, Input } from '@angular/core';
import { determineStorageUrl } from 'src/app/common/storage-tools';
import { RecipeSearchResult } from 'src/app/models/recipe-search-result.model';
import { Settings } from 'src/app/models/Settings';
import { FoodPortalStateService } from 'src/app/services/food-portal-state.service';
import { FoodPortalService } from 'src/app/services/food-portal.service';

@Component({
  selector: 'pi-recipe-card',
  standalone: false,
  templateUrl: './recipe-card.component.html',
  styleUrl: './recipe-card.component.scss'
})
export class RecipeCardComponent {

  @Input() recipe: RecipeSearchResult;

  private state = inject(FoodPortalStateService);
  private svc = inject(FoodPortalService);

  public settings: Settings;
  public storageUrl: string;


  constructor() {

    this.settings = this.state.portalSettings;

    this.storageUrl = determineStorageUrl();
  }

  photoUrl(item: RecipeSearchResult) {
    return this.storageUrl + '/' + item.photoUrl;
  }

  public tagName = (tagId: number): string => this.state.allTags.find(x => x.id === tagId).name;

  /**
   * Returns true if the specified recipe should have a missing allergens warning displayed
   * Always returns false if the recipe is set not to display allergen data
   * @param recipe
   */
  showMissingAllergensWarning(recipe: RecipeSearchResult): boolean {
    // if the recipe is set to not show allergen data return false
    if ((recipe.publicNutrition & 2) !== 2) return false;
    return !recipe.allergensComplete;
  }

  showContainsAllergenWarning(recipe: RecipeSearchResult): boolean {
    // if the recipe is set to not show allergen data return false
    if ((recipe.publicNutrition & 2) !== 2) return false;

    const allergies = this.svc.selectedAllergens;

    return allergies.some(x => recipe.allergens[x.name] === 1 || recipe.allergens[x.name] === 2);

  }

}
